import {Alert} from "@mui/lab";
import {FAILURE} from "../../actions/app-state-action";
import {useSelector} from "react-redux";

export default function ErrorMessage() {
    const {state, message} = useSelector(state => state.appState);
    return (state === FAILURE && <Alert severity="error" sx={{width:'100%'}}>{message}</Alert>);
}